module.exports = __webpack_public_path__ + "img/financial_overview.7cf6e582.svg";